import { getThemeAsset } from "@utils/theme";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { CoinJumpAnimation } from "../CoinJumpAnimation";
import FTDGiftText from "./FTDGiftText";
import { ANIMATION_STATE, LOOP_CONFIG, finalGlowVariant, initialGlowVariant } from "./utils";

const GiftTextButton = () => {
  const [isCoinVisible, setIsCoinVisible] = useState(false);
  const [giftAnimState, setGiftAnimState] = useState<ANIMATION_STATE>(ANIMATION_STATE.IDLE);

  const coinTimerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (coinTimerRef.current) clearTimeout(coinTimerRef.current);
    };
  }, []);

  // Start coin animation when pulsing begins
  useEffect(() => {
    if (giftAnimState === ANIMATION_STATE.PULSING) {
      if (coinTimerRef.current) clearTimeout(coinTimerRef.current);
      coinTimerRef.current = setTimeout(() => {
        setIsCoinVisible(true);
      }, LOOP_CONFIG.COIN_BURST_DELAY);
    } else {
      setIsCoinVisible(false);
      if (coinTimerRef.current) clearTimeout(coinTimerRef.current);
    }
  }, [giftAnimState]);

  const handleAnimationStateChange = (state: ANIMATION_STATE) => {
    setGiftAnimState(state);
  };

  return (
    <div className="absolute left-1/2 top-0 -z-10 inline-block h-full w-full -translate-x-1/2">
      <motion.img
        src={getThemeAsset("/images/register-gift-label/bg-initial-glow.png")}
        variants={initialGlowVariant}
        initial={ANIMATION_STATE.IDLE}
        animate={giftAnimState}
        className="pointer-events-none absolute bottom-full left-1/2 mb-4 h-[88px] w-[410px] max-w-none"
        style={{
          zIndex: -2,
          bottom: "calc(100% + 16px - 40px)",
          clipPath: "inset(0 0 3px 0)",
          WebkitClipPath: "inset(0 0 3px 0)",
        }}
      />
      <motion.img
        key="ftd-gift-glow"
        src={getThemeAsset("/images/register-gift-label/bg-final-glow.png")}
        alt=""
        className="pointer-events-none absolute bottom-full left-1/2 mb-4 h-[88px] w-[410px] max-w-none"
        style={{
          zIndex: -2,
          bottom: "calc(100% + 16px - 40px)",
          clipPath: "inset(0 0 3px 0)",
          WebkitClipPath: "inset(0 0 3px 0)",
        }}
        variants={finalGlowVariant}
        initial={ANIMATION_STATE.IDLE}
        animate={giftAnimState}
        aria-hidden="true"
      />

      <div style={{ transform: "translateY(-34px)" }}>
        <CoinJumpAnimation
          isVisible={isCoinVisible}
          effectCount={Infinity}
        />
      </div>

      <div
        className="absolute bottom-full left-1/2 mb-1 w-fit -translate-x-1/2"
        style={{ zIndex: 0 }}
      >
        <FTDGiftText
          zIndex={0}
          onAnimationStateChange={handleAnimationStateChange}
          className="relative"
        />
      </div>
    </div>
  );
};

export default GiftTextButton;
